<template>
  <i
    :class="`iconfont d-${name}`"
    @click="$emit('click')"
  ></i>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
@import '//at.alicdn.com/t/font_1560419_kgshxgexolg.css';
</style>
